import React from 'react';
import AuthHeader from './AuthHeader';
import StyledContainer from './StyledContainer';
import AuthFooter from './AuthFooter';

const NewPasswordSuccess: React.FC = () => (
    <StyledContainer>
      <AuthHeader />
      <div className="row">
        <div className="col-md-12">
          <div className="text-center m-b-md">
            <h3>Password Succesfully Reset</h3>
          </div>
          <div className="hpanel">
            <div className="panel-body">
              <h4>
                Your password has been reset succesfully.{' '}
                <a href="/redirect_login">Please login.</a>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <AuthFooter />
    </StyledContainer>
  );

export default NewPasswordSuccess;
